'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getGettextInstance;

var _nodeGettext = require('node-gettext');

var _nodeGettext2 = _interopRequireDefault(_nodeGettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Returns an instance of node-gettext, populate with the
// given messages and set to use the given locale.
function getGettextInstance(messages, locale, options) {
  var gt = new _nodeGettext2.default(options);

  Object.keys(messages).forEach(function (lang) {
    gt.addTranslations(lang, 'messages', messages[lang]);
  });

  gt.setLocale(locale);

  return gt;
}